import Swiper, { Navigation, Pagination, Controller, Thumbs, EffectFade, EffectCoverflow, A11y, FreeMode, Lazy } from 'swiper';
import { a11y, getSlideIndexByAttr } from './utils/slider';
import { scrollTo } from './utils/general';

let featuredSlider = null;
let valueCardSlider = null;

window.addEventListener('DOMContentLoaded', () => {
  
  // Featured slider
  if (document.querySelector('[data-slider="featured"]')) {
    CMS.DataStore.subscribe('sliders/featured_lg', ({ match }) => {
      if (typeof featuredSlider !== 'undefined' && featuredSlider) {
        featuredSlider.destroy();
      }
      if (match) {
        featuredSlider = initFeaturedSlider();
      } else {
        featuredSlider = initFeaturedSlider({ type: 'mobile' });
      }
    });
    CMS.watchBreakpoint('(min-width: 992px)', 'sliders/featured_lg', CMS.DataStore);
  }

  // Value card slider
  if (document.querySelector('[data-slider="value_cards"]')) {

    // mobile
    CMS.DataStore.subscribe('sliders/value_cards_sm', ({ match }) => {
      if (match) {
        // < 768px
        if (typeof valueCardSlider !== 'undefined' && valueCardSlider) {
          valueCardSlider.destroy();
          valueCardSlider = null;
        }
        valueCardSlider = initValueCardSlider({
          effect: 'coverflow',
        });
      }
    });
    CMS.watchBreakpoint('(max-width: 767px)', 'sliders/value_cards_sm', CMS.DataStore);

    // tablet
    CMS.DataStore.subscribe('sliders/value_cards_md', ({ match }) => {
      if (match) {
        // >= 768px && < 992px
        if (typeof valueCardSlider !== 'undefined' && valueCardSlider) {
          valueCardSlider.destroy();
          valueCardSlider = null;
        }
        valueCardSlider = initValueCardSlider();
      }
    });
    CMS.watchBreakpoint('(min-width: 768px) and (max-width: 991px)', 'sliders/value_cards_md', CMS.DataStore);

    // large tablet
    CMS.DataStore.subscribe('sliders/value_cards_lg', ({ match }) => {
      if (match && typeof valueCardSlider !== 'undefined' && valueCardSlider) {
        valueCardSlider.destroy(true, true);
        valueCardSlider = null;
      }
    });
    CMS.watchBreakpoint('(min-width: 992px)', 'sliders/value_cards_lg', CMS.DataStore);
  }

  // Featured product sliders
  if (document.querySelectorAll('[data-slider="product_featured"]').length > 0) {
    Array.from(document.querySelectorAll('[data-slider="product_featured"]')).forEach(sliderEl => {
      new Swiper(sliderEl, {
        modules: [Navigation, Pagination, A11y, Lazy],
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 500,
        lazy: true,
        navigation: {
          nextEl: sliderEl.querySelector('[data-slider-nav="next"]'),
          prevEl: sliderEl.querySelector('[data-slider-nav="prev"]'),
        },
        pagination: {
          el: sliderEl.querySelector('[data-slider-pagination]'),
          type: 'bullets',
          clickable: true,
        },
        a11y: a11y(),
      });
    });
  }

  // Product details page: Product image sliders and product packing menu
  if (
    document.querySelector('[data-slider="product_details"]')
  ) {
    const sliderProductDetailsEl = document.querySelector('[data-slider="product_details"]');
    const sliderProductDetailsThumbsEl = document.querySelector('[data-slider="product_details_thumbs"]');
    const packingMenuEl = document.querySelector('[data-product-packing]');
    
    let sliderProductDetailsThumbs = null;
    if (sliderProductDetailsThumbsEl) {
      sliderProductDetailsThumbs = new Swiper(sliderProductDetailsThumbsEl, {
        modules: [FreeMode, Lazy],
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        lazy: true,
      });
    }
    
    const sliderProductDetails = new Swiper(sliderProductDetailsEl, {
      modules: [Navigation, A11y, Thumbs, Lazy],
      slidesPerView: 1,
      spaceBetween: 0,
      watchSlidesProgress: true,
      lazy: true,
      a11y: a11y(),
      navigation: {
        prevEl: sliderProductDetailsEl.querySelector('[data-slider-nav="prev"]'),
        nextEl: sliderProductDetailsEl.querySelector('[data-slider-nav="next"]'),
      },
      thumbs: {
        swiper: sliderProductDetailsThumbs,
      },
      on: {
        init: (swiper) => {
          const slideEl = swiper.slides[swiper.activeIndex];
          const packing = slideEl.getAttribute('data-packing').trim() || null;
          if (packingMenuEl && packing) {
            Array.from(packingMenuEl.querySelectorAll('.nav-link')).forEach(btnEl => btnEl.classList.remove('active'));
            packingMenuEl.querySelector(`.nav-link[data-packing="${packing}"]`).classList.add('active');
          }
        },
        slideChange: (swiper) => {
          const slideEl = swiper.slides[swiper.activeIndex];
          const packing = slideEl.getAttribute('data-packing').trim() || null;
          if (packingMenuEl) {
            Array.from(packingMenuEl.querySelectorAll('.nav-link')).forEach(btnEl => btnEl.classList.remove('active'));
            if (packing) {
              packingMenuEl.querySelector(`.nav-link[data-packing="${packing}"]`).classList.add('active');
            }
          }
        }
      },
    });

    // Packing menu
    if (packingMenuEl) {

      // Menu clicks
      Array.from(document.querySelectorAll('[data-product-packing] .nav-link')).forEach(btnEl => {
        btnEl.addEventListener('click', e => {
          e.preventDefault();
          const packing = btnEl.getAttribute('data-packing').trim() || '';
          const slideIndex = getSlideIndexByAttr(sliderProductDetails, packing);
          if (typeof slideIndex === 'number') {
            sliderProductDetails.slideTo(slideIndex, 500);
          }
        }, false);

        btnEl.addEventListener('keydown', e => {
          e.preventDefault();
        }, false);
      });

    }

  }

  // Recommended content sliders
  Array.from(document.querySelectorAll('[data-slider="recommended_content"]')).forEach(sliderEl => {
    new Swiper(sliderEl, {
      modules: [Navigation, A11y, Pagination],
      slidesPerView: 1,
      spaceBetween: 8,
      navigation: {
        prevEl: sliderEl.querySelector('[data-slider-nav="prev"]'),
        nextEl: sliderEl.querySelector('[data-slider-nav="next"]'),
      },
      pagination: {
        el: sliderEl.querySelector('[data-slider-pagination]'),
        type: 'bullets',
        clickable: true,
      },
      breakpoints: {
        540: {
          slidesPerView: 1.5,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        // 1200: {
        //   slidesPerView: 2.5,
        //   spaceBetween: 16,
        // },
      },
      a11y: a11y(),
    });
  });

  // Mini gallery sliders
  Array.from(document.querySelectorAll('[data-slider="mini_gallery"]')).forEach(sliderEl => {
    const sliderId = sliderEl.getAttribute('data-slider-id');
    const thumbsSliderEl = document.querySelector(`[data-slider="mini_gallery_thumbs"][data-slider-id="${sliderId}"]`);
    let miniGalleryThumbsSlider = null;

    if (thumbsSliderEl) {
      miniGalleryThumbsSlider = new Swiper(thumbsSliderEl, {
        modules: [FreeMode, Lazy],
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
        lazy: true,
      });
    }

    new Swiper(sliderEl, {
      modules: [Navigation, A11y, Thumbs, Lazy],
      slidesPerView: 1,
      autoHeight: true,
      spaceBetween: 0,
      watchSlidesProgress: true,
      lazy: true,
      a11y: a11y(),
      navigation: {
        prevEl: sliderEl.querySelector('[data-slider-nav="prev"]'),
        nextEl: sliderEl.querySelector('[data-slider-nav="next"]'),
      },
      thumbs: {
        swiper: miniGalleryThumbsSlider,
      },
    });
  });

  // Timeline sliders
  Array.from(document.querySelectorAll('[data-slider="timeline"]')).forEach(sliderEl => {
    const sliderId = sliderEl.getAttribute('data-slider-id');
    const timelineTimeSliderEl = document.querySelector(`[data-slider="timeline_time"][data-slider-id="${sliderId}"]`);

    if (timelineTimeSliderEl) {

      const timelineTimeSlider = new Swiper(timelineTimeSliderEl, {
        modules: [Controller, Navigation, A11y],
        slidesPerView: 2.5,
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 3.5,
          },
          992: {
            slidesPerView: 4.5,
          },
          1200: {
            slidesPerView: 5.5,
          },
        },
        navigation: {
          prevEl: timelineTimeSliderEl.querySelector('[data-slider-nav="prev"]'),
          nextEl: timelineTimeSliderEl.querySelector('[data-slider-nav="next"]'),
        },
        a11y: a11y(),
      });

      const timelineSilder = new Swiper(sliderEl, {
        modules: [Controller, A11y, Lazy, EffectCoverflow],
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        allowTouchMove: false,
        autoHeight: true,
        lazy: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          scale: 0.9,
          slideShadows: true,
        },
        a11y: a11y(),
      });

      // set controls to each other
      timelineTimeSlider.controller.control = timelineSilder;
      timelineSilder.controller.control= timelineTimeSlider;

      // timeline time slider: slide to clicked slide
      timelineTimeSlider.on('click', swiper => {
        if (swiper.clickedIndex !== swiper.activeIndex) {
          swiper.slideTo(swiper.clickedIndex, 500);
        }
      });

    }

  });

  // Multi-step form sliders
  Array.from(document.querySelectorAll('[data-slider="multi_step_form"]')).forEach(sliderEl => {
    const navButtonEls = Array.from(sliderEl.querySelectorAll('[data-slider-to-slide]'));

    const slider = new Swiper(sliderEl, {
      modules: [A11y],
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      autoHeight: true,
      a11y: a11y(),
    });

    // update nav. buttons on slide change
    slider.on('slideChange', swiper => {
      // set nav button classes
      navButtonEls.forEach((el, i) => {
        if (i < swiper.activeIndex) {
          el.classList.remove('active');
          el.classList.add('done');
        } else if (i === swiper.activeIndex) {
          el.classList.add('active');
          el.classList.remove('done');
        } else {
          el.classList.remove('active');
          el.classList.remove('done');
        }
      });
    });

    // auto-scroll viewport after slide change
    slider.on('slideChangeTransitionEnd', () => {
      scrollTo(sliderEl);
    });

    // watch slide content changes
    const observerCallback = mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          slider.updateAutoHeight(0);
        }
      });
    };
    const observer = new MutationObserver(observerCallback);
    Array.from(sliderEl.querySelectorAll('.swiper-slide')).forEach(targetNode => {
      observer.observe(targetNode, {
        childList: true,
        subtree: true,
      });
    });

    // subscribe to form error events:
    CMS.DataStore.subscribe('multi_step_form/error', ({ firstError }) => {
      const errorId = firstError.getAttribute('id');
      const slideIndex = [...slider.slides].findIndex(slide => slide.querySelector(`#${errorId}`));
      if (slideIndex > -1) {
        slider.slideTo(slideIndex, 500);
      }
    });

    // slider navigation buttons
    navButtonEls.forEach(btnEl => {
      btnEl.addEventListener('click', e => {
        e.preventDefault();
        
        const slideIndex = parseInt(btnEl.getAttribute('data-slider-to-slide'));
        slider.slideTo(slideIndex, 500);
      }, false);
    });
  });

});

/**
 * Normalize featured slider z-index values
 * 
 * @param {Swiper} swiper - Swiper slider instance
 * @param {object} options - Optional settings
 * @param {string|HTMLElement} [options.activeSlide=.swiper-slide-visible] - Active slide CSS selector or HTML Element
 * 
 * @returns {void}
 */
const normalizeFeaturedSliderSlides = (swiper, options = {}) => {
  const _defaults = {
    activeSlide: '.swiper-slide-visible',
  };
  const opts = { ..._defaults, ...options };

  const currentSlideEl = swiper.el.querySelector(opts.activeSlide);
  Array.from(swiper.slides).forEach(slideEl => {
    slideEl.style.zIndex = 'initial';
  });
  currentSlideEl.style.zIndex = 2;
};

/**
 * Init featured slider
 * 
 * @param {object} options - Optional settings
 * @param {string} [options.type=desktop] - Slider type (desktop | mobile)
 * @param {string|HTMLElement} [options.sliderEl=[data-slider="featured"]] - Slider CSS selector / HTML element
 * 
 * @returns {Swiper}
 */
const initFeaturedSlider = (options = {}) => {
  const _defaults = {
    type: 'desktop',
    sliderEl: '[data-slider="featured"]',
  };
  const opts = { ..._defaults, ...options };
  const sliderEl = (typeof opts.sliderEl === 'string') ? document.querySelector(opts.sliderEl) : sliderEl;
  
  // desktop
  const sliderOptions = {
    modules: [Navigation, Pagination, EffectFade, A11y, Lazy],
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: false,
    effect: 'fade',
    lazy: true,
    fadeEffect: {
      crossFade: true,
      transformEl: '.swiper-slide-inner',
    },
    navigation: {
      nextEl: sliderEl.querySelector('[data-slider-nav="next"]'),
      prevEl: sliderEl.querySelector('[data-slider-nav="prev"]'),
    },
    pagination: {
      el: sliderEl.querySelector('[data-slider-pagination]'),
      type: 'bullets',
      clickable: true,
    },
    a11y: a11y(),
    on: {
      init: (swiper) => {
        normalizeFeaturedSliderSlides(swiper);
      },
      slideChange: (swiper) => {
        normalizeFeaturedSliderSlides(swiper);
      },
    },
  };

  // mobile
  if (opts.type === 'mobile') {
    sliderOptions.autoHeight = true;
  }

  // init slider
  return new Swiper(sliderEl, sliderOptions);
};

/**
 * Init value card slider
 * 
 * @param {object} options - Optional settings
 * @param {string|null} [options.effect=null] - Slider effect (null | coverflow)
 * @param {string|HTMLElement} [options.sliderEl=[data-slider="intro_cards"]] - Slider CSS selector / HTML element
 * 
 * @returns {Swiper}
 */
const initValueCardSlider = (options = {}) => {
  const _defaults = {
    effect: null,
    sliderEl: '[data-slider="value_cards"]',
  };
  const opts = { ..._defaults, ...options };
  const sliderEl = (typeof opts.sliderEl === 'string') ? document.querySelector(opts.sliderEl) : sliderEl;
  const totalCards = sliderEl.querySelectorAll('.swiper-slide').length;

  // card spacing values
  const spacingMap = {
    2: 64,
    3: 32,
    4: 16,
  };
  const spaceBetween = (typeof spacingMap[totalCards] !== 'undefined') ? spacingMap[totalCards] : 8;

  // tablet
  let sliderOptions = {
    modules: [Navigation, A11y],
    slidesPerView: 3.5,
    spaceBetween,
    navigation: {
      nextEl: sliderEl.querySelector('[data-slider-nav="next"]'),
      prevEl: sliderEl.querySelector('[data-slider-nav="prev"]'),
    },
    a11y: a11y(),
  };

  // mobile (coverflow)
  if (opts.effect === 'coverflow') {
    sliderOptions = {
      modules: [Navigation, EffectCoverflow, A11y],
      slidesPerView: 1.25,
      spaceBetween: 0,
      centeredSlides: true,
      navigation: {
        nextEl: sliderEl.querySelector('[data-slider-nav="next"]'),
        prevEl: sliderEl.querySelector('[data-slider-nav="prev"]'),
      },
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        scale: 0.96,
        rotate: 0,
        slideShadows: true,
        depth: 220,
      },
      breakpoints: {
        370: {
          slidesPerView: 1.5,
          spaceBetween: 0,
        },
        540: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        620: {
          slidesPerView: 2.5,
          spaceBetween: 0,
        },
      },
      a11y: a11y(),
    };
  }

  // init slider
  return new Swiper(sliderEl, sliderOptions);
};
